// 双重预防体系
<template>
  <div class="main">
    <div class="banana">
      <img src="../assets/img/banner/双重.png" alt />
    </div>
    <div class="center">
      <div class="nav">
        <p>
          当前位置：
          <span @click="shouye" class="navvv">首页</span> >
          双重预防体系咨询服务
        </p>
      </div>
      <h1 class="title">双重预防体系咨询服务</h1>
      <p>包括安全评估及认证服务，双重预防体系实施，双重预防体系建设咨询、双重预防体系建设培训、双重预防体系平台建设以及不同行业、特殊环境双体系定制开发等内容。</p>
      <p>指导企业建立组织机构、完善工作制度，建立健全档案管理制度，风险点排查确定，危险源识别、分析，风险评价，制定风险管控措施；隐患分级与分类，重大隐患治理。</p>

      <h1 class="two">双重预防体系建设思路</h1>
      <p>1.企业根据自身情况成立负责双重预防体系工作的领导小组，健全完善风险分级管控和隐患排查治理制度，对双重预防体系建设所需的相关知识开展分层次、有针对性的人员培训。</p>
      <p>2.进行风险分级管控工作，根据评估结果划分风险等级，制定相应的分级管控措施进行风险分级管控。</p>
      <p>3.根据风险情况做相应的隐患排查治理工作。及时修正发现的问题和偏差，完善安全风险管控制度和隐患治理措施，持续改进提升，不断提高安全管理水平。</p>

      <div class="oneMsg"></div>
      <h1>产品功能</h1>
      <div class="twoMsg"></div>

      <div class="zhuanhuan">
        <div class="colmd">
          <div class="col-md-3 tab1 tab" :class="{ active1: one }">
            <p @click="onee">风险分级管控</p>
          </div>
          <div class="col-md-3 tab2 tab" :class="{ active1: two }">
            <p @click="twoo">隐患排查治理</p>
          </div>
          <div class="col-md-3 tab2 tab" :class="{ active1: three }">
            <p @click="threee">安全教育培训</p>
          </div>
          <div class="col-md-3 tab2 tab" :class="{ active1: four }">
            <p @click="fourr">数据分析</p>
          </div>
        </div>
        <div class="col-md-12 row animate-box">
          <div class="application-list2 activeApp col-md-12" v-show="one">
            <div style="display: flex;justify-content: space-around;">
              <div class="sj" style="width: 45%;line-height: 40px;padding-bottom: 40px;">
                <p class="xxmsg">
                  ①
                  风险分级管控包括风险点采集，风险源辨识，风险分级管控，风险四色图。
                </p>
                <p class="xxmsg">
                  ②
                  安全检查分为专项检查和日常巡检，公司领导/项目领导可根据企业自身制定的安全管理要求，制定安全检查目标并建立对应的检查任务，保证安全检查任务落实到具体责任人。
                </p>
                <p class="xxmsg">
                  ③
                  可在系统中跟踪查询各项目及相关责任人安全检查落实情况，远程快速掌握各项目及相关责任人履职情况。
                </p>
                <p class="xxmsg">
                  ④
                  针对安全管理中存在的专项检查，现场负责人员可通过手机APP提交专项检查任务，参与人按说明情况检查完成后提交系统。现场负责人员可根据系统来追踪专项检查完成情况，提升协作效率。
                </p>
              </div>
              <img src="../assets/img/双重/three.png" alt style="width: 45%;" />
            </div>
          </div>
          <div class="application-list2 col-md-12" v-show="two">
            <div style="display: flex;justify-content: space-around;">
              <div class="sj" style="width: 45%;line-height: 40px;padding-bottom: 40px;">
                <p class="xxmsg">
                  ①
                  检查人按照隐患排查计划进行隐患排查，排查过程中确认为隐患的，直接推送给责任人及整改人，责任人及整改人收到工作指令后进行隐患整改，整改完成后提交验收申请。若验收不通过，则打回重新进行整改，待整改复查后结束验收流程。
                </p>
                <p class="xxmsg">
                  ②
                  WEB端可实时追踪整改进度，超期未验收会上报进行任务督促，验收完成后生成验收记录，验收数据上传云端并提供历史数据备份、数据分析、数据统计等功能。
                </p>
              </div>
              <img src="../assets/img/双重/four.png" alt style="width: 45%;" />
            </div>
          </div>
          <div class="application-list2 col-md-12" v-show="three">
            <div style="display: flex;justify-content: space-around;">
              <div class="sj" style="width: 45%;line-height: 40px;padding-bottom: 40px;">
                <p
                  style="text-indent: 36px;"
                  class="xxmsg"
                >通过系统标准化体系的协助流程以及查看系统历史台账等，新人可依据公司安全管理流程及规定动作提交任务，降低了新人的安全教育成本，同时提升了新人的安全方面专业能力。对人员安全教育培训的内容，培训资料，培训考核结果，安全交底等可以记录留痕，让安全教育培训有计划，有标准，有落实，有效益。同时公司体系规范，规章制度，项目资料等可以通过云端存储，让项目人员随时随地接受安全教育和学习。</p>
              </div>
              <img src="../assets/img/双重/five.png" alt style="width: 45%;" />
            </div>
          </div>
          <div class="application-list2 col-md-12" v-show="four">
            <div style="display: flex;justify-content: space-around;">
              <div class="sj" style="width: 45%;line-height: 40px;padding-bottom: 40px;">
                <p class="xxmsg">
                  ①
                  通过对数据分析，能够快速统计隐患排查完成的情况，各类作业风险的比较，隐患整改率，检查类型分析等等信息。
                </p>
                <p class="xxmsg">
                  ②
                  通过隐患台账的分析，可以快速获取到项目隐患情况，责任人及整改人，整改日期，整改状态，隐患验收等等信息。
                </p>
              </div>
              <img src="../assets/img/双重/six.png" alt style="width: 45%;" />
            </div>
          </div>
        </div>
      </div>

      <h1>BI大屏</h1>
      <div class="threeMsg"></div>
    </div>

    <!-- 产品优势 -->
    <div class="yftx_content bottom_swiper animate-box" style="margin-top: 50px;">
      <div class="col-md-13" style="padding: 0;margin: 0;">
        <div
          class="yftx_title_wihte"
          style="margin-bottom: 50px; width: 100%;padding-top: 50px;"
        >产品优势</div>
      </div>
      <div>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="item">
                <div class="top text-center">
                  <p
                    style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: 25px;text-align: center;line-height: 100px;"
                  >风险隐患预防</p>
                </div>
                <div class="bottom">
                  <p
                    style="text-indent: 36px;"
                  >包括风险分级管控体系和隐患排查治理体系，其目的是要把安全生产关口前移，把事故隐患提前消灭掉。系统通过风险源识别、重大安全问题提前预警，对风险点设置监管任务，定时检查，动态展示近期风险源检查的结果，如重大问题未解决则会向经理部、分公司等相关负责人推送通知。</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="item">
                <div class="top text-center">
                  <p
                    style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: 25px;text-align: center;line-height: 100px;"
                  >建立健全档案制度规范</p>
                </div>
                <div class="bottom">
                  <p
                    style="text-indent: 36px;"
                  >系统将操作流程与双重安全预防体系管理的标准相结合，依据项目进度和验收标准，合理制定安全检查的工作计划，设置标准化风险识别和隐患管控流程规范，每一处风险点都有对应的责任人及检查人进行监督，在实践中与企业安全管理体系相辅相成，可协助企业完善自身安全管理体系。</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="item">
                <div class="top text-center">
                  <p
                    style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: 25px;text-align: center;line-height: 100px;"
                  >责任明确到人</p>
                </div>
                <div class="bottom">
                  <p
                    style="text-indent: 36px;"
                  >系统中，通过现场责任区域的划分，协作过程中对检查人、整改人的通知提醒以及抄送信息，将不同部门的人员与统一任务管理，明确各方生产责任，集团领可通过系统查看各项目现场真实数据，远程监督各经理部和项目人员。</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="item">
                <div class="top text-center">
                  <p
                    style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: 25px;text-align: center;line-height: 100px;"
                  >安全教育培训</p>
                </div>
                <div class="bottom">
                  <p
                    style="text-indent: 36px;"
                  >通过系统标准化体系的协助流程以及查看系统历史台账等，新人可依据公司安全管理流程及规定动作提交任务，降低了新人的教育成本，同时提升新人安全方面的专业能力。</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="item">
                <div class="top text-center">
                  <p
                    style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: 25px;text-align: center;line-height: 100px;"
                  >专项检查</p>
                </div>
                <div class="bottom">
                  <p
                    style="text-indent: 36px;"
                  >集团、公司领导可下发安全专项检查任务。按照分公司、项目部自查、总部督查的原则，对在建工程的危险性较大分部分项工程，重点为深基坑、高大脚手架、高大模板等工程进行全方位、全面检查。检查中发现的隐患，在平台上发起隐患处理流程，跟踪任务进展及落实情况，方便事后责任追溯。</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="item">
                <div class="top text-center">
                  <p
                    style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: 25px;text-align: center;line-height: 100px;"
                  >风险四色图</p>
                </div>
                <div class="bottom">
                  <p
                    style="text-indent: 36px;"
                  >施工场所、生产设施等区域存在的重大风险、较大风险、一般风险和低风险，分别用红、橙、黄、蓝四种颜色标示在总平面布置图中。各个风险点关联对应的风险等级、责任人及可能导致的事故等信息，管理者可时刻了解项目风险分布状况及动态管理信息。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  props: {},
  data() {
    return {
      one: true,
      two: false,
      three: false,
      four: false,
      active: true,
    };
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      autoplay: 3000,
      autoplayDisableOnInteraction: true,
      effect: "coverflow",
      slidesPerView: 3,
      centeredSlides: true,
      coverflow: {
        rotate: 30,
        stretch: 10,
        depth: 60,
        modifier: 2,
        slideShadows: true,
      },
    });
  },
  methods: {
    onee() {
      this.one = true;
      this.two = false;
      this.three = false;
      this.four = false;
    },
    twoo() {
      this.two = true;
      this.one = false;
      this.three = false;
      this.four = false;
    },
    threee() {
      this.three = true;
      this.one = false;
      this.two = false;
      this.four = false;
    },
    fourr() {
      this.four = true;
      this.one = false;
      this.two = false;
      this.three = false;
    },
    shouye() {
      this.$router.replace("/");
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
@import "../assets/css/swiper-3.4.2.min.css";
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    // background: url("../assets/img/banner/双重.png") center no-repeat;
    // background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .center {
    width: 1197px;
    // padding: 0rem 3.6rem;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 38px;
      margin-bottom: 50px;
      p {
        font-size: 12px;
        text-indent: 0;
        line-height: 36px;
        color: #666666;
      }
    }
    h1 {
      opacity: 1;
      font-size: 35px;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
      line-height: 75px;
    }
    p {
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #231815;
      line-height: 30px;
      text-indent: 2em;
    }
    .two {
      margin-top: 70px;
    }
    .oneMsg {
      width: 1197px;
      height: 1742px;
      opacity: 1;
      background: url("../assets/img/双重/one.png") 0 0 no-repeat;
      background-size: 100% 100%;
      margin-top: 62px;
      margin-bottom: 101px;
    }
    .twoMsg {
      width: 1201px;
      height: 557px;
      opacity: 1;
      background: url("../assets/img/双重/two.png") 0 0 no-repeat;
      background-size: 100% 100%;
      margin-bottom: 102px;
    }
    .threeMsg {
      width: 883px;
      height: 496px;
      margin: 35px auto 77px;
      background: url("../assets/img/双重/图层 2@2x.png") 0 0 no-repeat;
      background-size: 100% 100%;
    }
    .zhuanhuan {
      .colmd {
        width: 100%;
        display: flex;
        justify-content: left;
        .tab {
          width: 220px;
          height: 30px;
          background: url("../assets/img/双重/jpg/组3.png") 0 0 no-repeat;
          background-size: 100% 100%;
          padding-bottom: 30px;
          margin-left: 50px;
          p {
            font-weight: bold;
            color: #ffffff;
            width: 100%;
            font-size: 20px;
            text-align: center;
            text-indent: 0;
            margin-top: 8px;
            margin-left: -3px;
          }
        }
        .active1 {
          background: url("../assets/img/双重/jpg/组1.png") 0 0 no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .lunbo {
    width: 100%;
    height: 863px;
    background: url("../assets/img/双重/bj.jpg") center no-repeat;
    background-size: 100% 100%;
    position: relative;
    .swp {
      position: absolute;
      top: 180px;
    }
  }
}
.col-md-12 {
  height: 700px;
}
.xxmsg {
  line-height: 37px !important;
  margin-bottom: 48px;
}

.yftx_title {
  text-align: center;
  font-size: 30px;
  color: #3a69b2;
  font-weight: bold;
  margin: 30px 0 18px;
}

.yftx_title_wihte {
  text-align: center;
  font-size: 30px;
  color: #ffffff;
  font-weight: bold;
  margin-top: 50px;
}

.yftx_detail {
  font-size: 16px;
  color: #333333;
  /* margin-top: .3rem; */
  text-indent: 50px;
}
.yftx_title_wihte {
  text-align: center;
  font-size: 30px;
  color: #ffffff;
  font-weight: bold;
  margin-top: 50px;
}
.bottom_swiper {
  height: 991px;
  background-image: url("../assets/img/双重/bj.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.swiper-container {
  width: 1500px;
  height: 600px;
  padding: 40px;
}
.swiper-slide {
  width: 470px;
  // height: 570px;
}

.item {
  padding: 20px;
}

.item .top {
  width: 67%;
  height: 100px;
  background: url("../assets/img/双重/5c3c6e18c91123.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
}

.item .bottom {
  width: 90%;
  height: 400px;
  margin: 30px auto 0;
  background: url("../assets/img/双重/5c3c6e18c9112.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #ffffff;
  padding: 20px;
  p {
    line-height: 2;
  }
}

#fh5co-services-section {
  padding: 0;
}

.bottom {
  p {
    display: block;
  }
}
</style>
